import Api, {ApiCall, ApiRequest} from "@/lib/Api";

export default {
    state : {
        recipes : []
    },
    getters : {
        allRecipes: state => state.recipes
    },
    actions : {
        async getRecipes({commit}) {
            const recipes = await ApiRequest(ApiCall(Api.ListRecipes));
            return await commit('setRecipes', recipes);
        },
        async updateRecipe({commit}, [recipe, id]) {
            await ApiRequest(ApiCall(Api.UpdateRecipe, recipe, id))
            return await commit('saveRecipe', [recipe, id])
        },
        async createRecipe({commit}, recipe) {
            const res = await ApiRequest(ApiCall(Api.CreateRecipe, recipe))
            recipe.id = res.insertId
            return await commit('saveRecipe', [recipe, null])
        },
        async deleteRecipe({commit}, id) {
            await ApiRequest(ApiCall(Api.DeleteRecipe, id))
            return await commit('deleteRecipe', id)
        },

    },
    mutations : {
        setRecipes: (state, recipes) => state.recipes = recipes,
        saveRecipe: (state, [recipe, id]) => {
            if (id) {
                state.recipes = state.recipes.map(it => it.id === recipe.id ? recipe : it)
            }
            else {
                state.recipes = [...state.recipes, recipe];
            }
            return state
        },
        deleteRecipe(state, id) {
            state.recipes = state.recipes.filter(it => it.id !== id)
        },
    }
}
